import React from "react";
import { CButton } from "@coreui/react";
import { useHistory } from "react-router-dom";

import elcamino from "../../assets/image/elcamino-white.png";

import "./styles.css";

const NoBooking = () => {
  const history = useHistory();
  return (
    <div className="principal">
      <div className="content">
        <div className="overlay"></div>

        <video
          playsInline="playsInline"
          autoPlay="autoplay"
          muted="muted"
          loop="loop"
        >
          <source
            src="https://firebasestorage.googleapis.com/v0/b/appreservaselcamino.appspot.com/o/videoplayback.mp4?alt=media&token=7ae2cfcc-b190-43c7-a9d6-94230769e500"
            type="video/mp4"
          />
        </video>

        <div className="container h-100">
          <div className="d-flex h-100 text-center align-items-center">
            <div className="w-100 text-white">
              <img src={elcamino} alt="El Camino" className="logo"/>
              <h1 className="display-5">¡Hola amado!</h1>
              <p className="lead mb-0">
                Te recordamos que la reserva es solo para <span>IGLEKIDS.</span> Los
                servicios principales, NO requieren reserva.
              </p>
              <CButton
                color="warning"
                onClick={() => history.push("/iglekids")}
                size="md"
                style={{ marginTop: 20, color: 'white', fontWeight: 700 }}
              >
                Ir a registro para Iglekids
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoBooking;
